import { isNull } from 'lodash';
import { pdfClientId } from '../../../../../bootstrap.json';
import * as PnpDocActions from '../pnp-approval.actions'
import * as PnpDocsActions from '../../pnp-docs.actions'
import { IDS } from '../pnp-approval.constants';
/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpApprovalDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $scope, $rootScope, FileActions, Notifier, DocumentManager, AuthService) {
        const unsubscribe = $ngRedux.connect(({ policies }) => ({
            pnpDocument: policies.pnpDocument
        }), {
            ...PnpDocActions,
            ...PnpDocsActions
        })(this);

        /**
          * @function $onInit
          */
        this.$onInit = () => {
            this.getDocumentRiskLevels();
            this.title = 'Document View'
            this.unsavedChanges = false;
            this.script = null;
            this.action = (this.pnpDocument.reviewType === 'Document Review Task') ? 'Complete Review' : 'Approve'

            this.stateIdentifier = 'pnpDocument';
            this.identifier = IDS.app_policies_documents_approval;
            this.state = IDS.app_policies_documents_approval_details;

            if (!window.adobe_dc_sdk || !window.adobe_dc_sdk["dc-core-loaded"]) {
                this.loadAdobeScript();
            } else {
                this.initializeAdobeViewer();
            }
        }

        this.loadAdobeScript = () => {
            this.script = document.createElement('script');
            this.script.src = "https://documentcloud.adobe.com/view-sdk/viewer.js";
            document.head.appendChild(this.script);

            this.script.onload = () => {
                // Initialize Adobe PDF Viewer after the script is loaded
                this.initializeAdobeViewer();
            };
        }


        this.initializeAdobeViewer = () => {
            if (document.readyState === "complete" && window.AdobeDC) {
                this.loadPDFView();
            } else {
                document.addEventListener("adobe_dc_view_sdk.ready", () => this.loadPDFView());
            }
        }

        this.loadPDFView = () => {
            const pdfCtrl = this;
            const pdfId = "77c6fa5d-6d74-4104-8349-657c8411a834";
            const pdfUrl = DocumentManager.toURL(this.pnpDocument.pdfPath)
            const user = AuthService.getUser();

            const profile = {
                userProfile: {
                    name: user.name,
                    firstName: user.name,
                    lastName: user.name
                }
            };

            let annotationManager;
            const adobeDCView = new AdobeDC.View({
                clientId: pdfClientId,
                divId: "adobe-dc-view"
            });

            const previewFilePromise = adobeDCView.previewFile({
                content: { location: { url: pdfUrl } },
                metaData: { fileName: "viewer.pdf", id: pdfId }
            }, {
                enableAnnotationAPIs: true,
                includePDFAnnotations: true,
                showAnnotationTools: true
            });

            adobeDCView.registerCallback(
                AdobeDC.View.Enum.CallbackType.GET_USER_PROFILE_API,
                () => {
                    return new Promise((resolve, reject) => {
                        resolve({
                            code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                            data: profile
                        });
                    });
                }
            );

            previewFilePromise.then(adobeViewer => {
                adobeViewer.getAnnotationManager().then(manager => {
                    annotationManager = manager;

                    // Apply annotations from backend when viewer is loaded
                    pdfCtrl.applyAnnotations = async function () {
                        try {
                            const annotations = pdfCtrl.pnpDocument.comment;
                            if (Array.isArray(annotations) && annotations.length > 0) {
                                await annotationManager.addAnnotations(annotations);
                                console.log("Annotations applied from backend:", annotations);
                            } else {
                                console.log("No annotations to apply.");
                            }
                        } catch (error) {
                            console.error("Failed to apply annotations:", error);
                        }
                    };

                    // Event listener for annotation changes
                    annotationManager.registerEventListener(
                        async function (event) {
                            // Check if the event type is a user-driven action (e.g., annotation added manually)
                            pdfCtrl.unsavedChanges = true;
                            const index = pdfCtrl.pnpDocument.comment.findIndex((data) => data.id === event.data.id)

                            switch (event.type) {
                                case "ANNOTATION_ADDED":
                                    if (index === -1) {
                                        pdfCtrl.pnpDocument.comment.push(event.data);
                                    }
                                    break;

                                case "ANNOTATION_UPDATED":
                                    if (index !== -1) {
                                        pdfCtrl.pnpDocument.comment[index] = event.data;
                                    }
                                    break;

                                case "ANNOTATION_DELETED":
                                    if (index !== -1) {
                                        pdfCtrl.pnpDocument.comment.splice(index, 1);
                                    }
                                    break;

                                default:
                                    break;
                            }
                        },
                        { listenOn: ["ANNOTATION_ADDED", "ANNOTATION_UPDATED", "ANNOTATION_DELETED"] }
                    );

                    // Apply annotations from backend when viewer is loaded
                    pdfCtrl.applyAnnotations();

                });
            }).catch(function (error) {
                console.error("Failed to load PDF or enable annotation APIs:", error);
            });
        }


        this.saveDetails = () => {
            this.saveDocument(this.pnpDocument).then(() => {
                Notifier.success('New comments have been successfully saved');
            }).catch(() => {
                Notifier.error('System Error!');
            });
        }

        this.getNotificationMessage = () => {
            switch (this.action) {
                case 'Complete':
                    return 'Document has been successfully completed';
                case 'Approve':
                    return 'Document has been successfully approved';
            }
        }

        this.reviewApproveDetails = () => {
            this.reviewApproveDocument(this.pnpDocument).then(() => {
                Notifier.success(this.getNotificationMessage());
            }).catch(() => {
                Notifier.error('System Error!');
            });
        }

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
            document.removeEventListener("adobe_dc_view_sdk.ready", () => this.loadPDFView());
        }

    },
    template: require('./pnp-approval-details.html')
}
